/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-underscore-dangle */

const defaultActions = {
  debugAction(...args) {
    console.log('Debug action')
    console.log(args)
  },
  switchState(element, item, context, api) {
    item.displayFunctionValues.state += 1
    item.displayFunctionValues.state
      %= item.displayFunctionValues.activeLayers.length
    api.action.redrawElement()
  },
  setRotation(element, item, context, api, params) {
    if (!item.displayFunctionValues.rotation) {
      item.displayFunctionValues.rotation = 0
    }
    if (params.rotation === 'left') {
      item.displayFunctionValues.rotation += 2
    } else if (params.rotation === 'right') {
      item.displayFunctionValues.rotation -= 2
    }
    api.action.redrawElement()
  },
  setGif(element, item, context, api) {
    api.drawHelpers.setGif(element, item, context, api)
  },
  _moveGuide(element, item, context, api, params) {
    const guides = api.geometry.localGuides()
    const guide = guides[params.editGuide]
    const guideCenter = api.Flatten.point(guide.x, guide.y)
    const localDelta = api.Flatten.vector(guideCenter, params.coords)
    let delta = api.Flatten.point(localDelta.x, localDelta.y)

    let matrix = new api.Flatten.Matrix()
    if (item.rotation) {
      matrix = matrix.rotate(-api.geometry.degToRad(item.rotation.angle))
    }
    matrix = matrix.scale(item.coords.w / 100, item.coords.h / 100)
    delta = delta.transform(matrix)
    switch (params.editGuide) {
      case 0:
        item.coords.x += delta.x
        item.coords.y += delta.y
        break
      case 1:
        item.coords.w += delta.x
        break
      case 2:
        item.coords.h += delta.y
        break
      case 3:
        item.coords.w += delta.x
        item.coords.h += delta.x / (item.coords.w / item.coords.h)
        break
      default:
        break
    }
    item.coords.w = Math.max(item.coords.w, 10)
    item.coords.h = Math.max(item.coords.h, 10)
    api.action.updateCoords()
    api.action.redrawElement()
  }
}

export default defaultActions
